<template>
    <VForm
        v-slot="validation"
        @submit="onSubmit">
        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
            <CategoryFormGeneral
                v-model="categoryModel"
                :loading="loading" />
        </div>

        <BaseSubmitButtons
            :submit-label="$t('categories.edit.save')"
            :loading="loading"
            :validation="validation"
            @cancel="emits('close')" />
    </VForm>
</template>

<script setup>
import {useEventBus} from "@vueuse/core"
import CategoryFormGeneral from "@/components/pages/categories/CategoryFormGeneral"
import {useNotification} from "@/composables/useNotification"
import {$lara} from "@/utils/$larafetch"

const props = defineProps({
    category: {
        type: Object,
        required: true
    }
})

const {$apiRoute} = useNuxtApp()
const {t: $t} = useI18n()
const emits = defineEmits(['categorySaved', 'close'])

const loading = ref(false)

const categoryModel = computed(() => props.category)

function onSubmit(values, actions) {
    loading.value = true

    const notification = useNotification()

    if (categoryModel.value.id) {
        $lara.put($apiRoute('spa.basedata.categories.update', {category: categoryModel.value.id}), {
            body: {...categoryModel.value}
        }).then((response) => {
            notification.success($t('categories.edit.saveCategorySuccess'))
            loading.value = false

            // open path to category in the tree structure
            useEventBus('newCategory').emit(response.data)
            emits('categorySaved')
        }).catch((error) => {
            if (typeof actions.setErrors === "function" && error?.data?.errors) {
                actions?.setErrors(error.data.errors)
            }
            notification.error($t('categories.edit.saveCategoryError'), error?.data?.message)
            loading.value = false
        })
    } else {
        $lara.post($apiRoute('spa.basedata.categories.store'), {
            body: {...categoryModel.value}
        }).then((response) => {
            loading.value = false
            notification.success($t('categories.create.saveCategorySuccess'))

            // open path to category in the tree structure
            useEventBus('newCategory').emit(response.data)
            emits('categorySaved')
        }).catch((error) => {
            loading.value = false
            actions.setErrors(error?.data?.errors)
            notification.error($translate('createCategoryError'), error?.data?.message)
        })
    }
}
</script>

